import { QuestionCircleFilled } from '@ant-design/icons';
import { i18nFormat } from '@unionfab/ufc-shop-commons';
import { Tooltip } from 'antd';

export const ShopQuoteTotalTips = () => {
  return (
    <Tooltip
      title={i18nFormat(
        '【Notice】Duties and additional taxes are not included in your total order amount. You are solely responsible for any duties, taxes, and fees related to your order.',
      )}
    >
      <QuestionCircleFilled style={{ color: '#faad14', marginLeft: 4 }} />
    </Tooltip>
  );
};

ShopQuoteTotalTips.displayName = 'ShopQuoteTotalTips';
